import { AppForm } from '../../../../../../../common/forms/app.form';
import { Injectable } from '@angular/core';
import {
  ApplicationAppEntityApplicationRead,
  ApplicationAppEntityApplicationWrite
} from '../../../../../../../openapi';
import { FormControl, Validators } from '@angular/forms';
import { CustomValidator, fromToDate } from '../../../../../../../common/forms/custom.validators';

export const submissionPurposeOptions: string[] = [
  'Wniosek o wydanie jednorazowego zezwolenia na sprzedaż detaliczną napojów alkoholowych',
  'Wniosek o wydanie zezwolenia na sprzedaż detaliczną napojów alkoholowych',
  'Wniosek o wydanie zezwolenia na sprzedaż detaliczną napojów alkoholowych dla przedsiębiorców, których działalność polega na dostarczaniu żywności na imprezy zamknięte organizowane w czasie i miejscu wyznaczonym przez klienta, w oparciu o zawartą z nim umowę'
];

@Injectable()
export class AlcoholicSalesPermitBaseInfoForm extends AppForm {

  public submissionPurposeOptions: string[] = submissionPurposeOptions;

  constructor() {
    super({
      submissionPurpose: new FormControl(submissionPurposeOptions.at(0), {
        nonNullable: true,
        validators: [Validators.required]
      }),

      alcoholUpTo45OffSite: new FormControl(false, { nonNullable: true, validators: [Validators.required] }),

      alcohol45To18OffSite: new FormControl(false, { nonNullable: true, validators: [Validators.required] }),

      alcoholAbove18OffSite: new FormControl(false, { nonNullable: true, validators: [Validators.required] }),

      salesPointAddress1: new FormControl(null, { validators: [Validators.required, Validators.maxLength(255)] }),
      storagePointAddress1: new FormControl(null, { validators: [Validators.required, Validators.maxLength(255)] }),

      salesPointAddress2: new FormControl(null, { validators: [Validators.maxLength(255)] }),
      storagePointAddress2: new FormControl(null, { validators: [Validators.maxLength(255)] }),

      salesPointAddress3: new FormControl(null, { validators: [Validators.maxLength(255)] }),
      storagePointAddress3: new FormControl(null, { validators: [Validators.maxLength(255)] }),

      eventStartDate: new FormControl(null, { validators: [Validators.required, CustomValidator.isValidDateFormat(), CustomValidator.minDate(new Date())] }),
      eventEndDate: new FormControl(null, { validators: [Validators.required, CustomValidator.isValidDateFormat()] }),
      eventName: new FormControl(null, { validators: [Validators.required, Validators.maxLength(255)] }),
      eventLocation: new FormControl(null, { validators: [Validators.required, Validators.maxLength(255)] }),

      businessActivity1: new FormControl(null, { validators: [Validators.required, Validators.maxLength(255)] }),
      businessActivity2: new FormControl(null, { validators: [Validators.maxLength(255)] }),
      businessActivity3: new FormControl(null, { validators: [Validators.maxLength(255)] }),
      businessActivity4: new FormControl(null, { validators: [Validators.maxLength(255)] }),
      businessActivity5: new FormControl(null, { validators: [Validators.maxLength(255)] })
    }, {
      validators: [
        fromToDate('eventStartDate', 'eventEndDate')
      ]
    });
    this.submissionPurposeChange(this.submissionPurposeOptions.at(0) || '');
  }

  public get submissionPurpose(): FormControl {
    return this.get('submissionPurpose') as FormControl;
  }

  public submissionPurposeChange(v: string): void {
    if (v === this.submissionPurposeOptions.at(2)) {
      this.removeControl('alcoholUpTo45OnSite');
      this.removeControl('alcohol45To18OnSite');
      this.removeControl('alcoholAbove18OnSite');
    } else {
      this.addControl('alcoholUpTo45OnSite', new FormControl(false, {
        nonNullable: true,
        validators: [Validators.required]
      }));
      this.addControl('alcohol45To18OnSite', new FormControl(false, {
        nonNullable: true,
        validators: [Validators.required]
      }));
      this.addControl('alcoholAbove18OnSite', new FormControl(false, {
        nonNullable: true,
        validators: [Validators.required]
      }));
    }
  }

  public override get valid(): boolean {
    if (this.submissionPurpose.value === this.submissionPurposeOptions.at(2)) {
      return super.valid && (this.get('alcoholUpTo45OffSite')?.value || this.get('alcohol45To18OffSite')?.value || this.get('alcoholAbove18OffSite')?.value);
    } else {
      return super.valid && (
        this.get('alcoholUpTo45OffSite')?.value
        || this.alcoholUpTo45OnSite?.value
        || this.get('alcohol45To18OffSite')?.value
        || this.alcohol45To18OnSite?.value
        || this.get('alcoholAbove18OffSite')?.value
        || this.alcoholAbove18OnSite?.value
      );
    }
  }

  public get alcoholUpTo45OnSite(): FormControl | null {
    return this.get('alcoholUpTo45OnSite') as FormControl | null;
  }

  public get alcohol45To18OnSite(): FormControl | null {
    return this.get('alcohol45To18OnSite') as FormControl | null;
  }

  public get alcoholAbove18OnSite(): FormControl | null {
    return this.get('alcoholAbove18OnSite') as FormControl | null;
  }

  public override patchFormValues(value: ApplicationAppEntityApplicationRead): void {
    this.submissionPurposeChange(value?.submissionPurpose || this.submissionPurposeOptions.at(0) || '');
    super.patchFormValues(value);
  }

  public toWriteModel(): ApplicationAppEntityApplicationWrite {
    return this.value;
  }
}
